
























































import { defineComponent, PropType } from '@vue/composition-api'
import { getCountries } from '~/api/Address/address'
import Autocomplete from '~/components/Autocomplete.vue'
import PhoneTextField from '~/components/PhoneTextField.vue'
import { VueForm } from '~/utils/interfaces'
import { CreateCarBooking } from '~/utils/interfaces/rentalCar'
import vRules from '~/utils/vRules'

export default defineComponent({
  components: { Autocomplete, PhoneTextField },
  props: {
    crud: {
      type: Object as PropType<CreateCarBooking>,
      required: true,
    },
  },
  data() {
    return {
      vRules,
    }
  },
  methods: {
    onNext() {
      return (this.$refs.form as VueForm).validate()
    },
    getCountries,
  },
})
